module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-8266af5129e8a899f18dfff614bf31b7.png";